import { useToast } from '@cian/ui-kit';
import { useEffect } from 'react';
import { FORM_SAVED_QUERY_PARAM, FORM_SAVED_TOAST_TEXT } from '../../constants/formSaved';

export const useFormSavedToast = () => {
  const toast = useToast({ placement: 'bottom-right' });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    if (!params.has(FORM_SAVED_QUERY_PARAM)) {
      return;
    }

    toast.open({
      type: 'success',
      text: FORM_SAVED_TOAST_TEXT,
      dataTestId: 'form-saved-toast',
    });

    params.delete(FORM_SAVED_QUERY_PARAM);
    const search = params.toString();
    const nextUrl = `${window.location.pathname}${search ? `?${search}` : ''}${window.location.hash}`;
    window.history.replaceState(null, '', nextUrl);
  }, [toast]);
};
